import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';

function getFullName(initials, firstName, nameAffix, lastName) {
  const name = [initials, firstName];

  if (nameAffix) {
    name.push(nameAffix);
  }

  name.push(lastName);

  return name.join(' ');
}

function getStreet(houseNumber, houseNumberAddition, street) {
  const address = [street, String(houseNumber)];

  if (houseNumberAddition) {
    address.push(houseNumberAddition);
  }

  return address.join(' ');
}

function getGender(gender) {
  switch (gender) {
    case 'male':
      return 'man';
    case 'female':
      return 'vrouw';
    default:
      return 'x';
  }
}

export const Summary = ({
  initials,
  firstName,
  nameAffix,
  lastName,
  gender,
  dateOfBirth,
  postalCode,
  houseNumber,
  houseNumberAddition,
  street,
  city,
  emailAddress,
  phoneNumber,
  newsletterSubscription,
  membership,
}) => {
  return (
    <>
      <Heading>Bestelling</Heading>
      <S.Paragraph>{membership}</S.Paragraph>
      <Heading>Gegevens</Heading>
      <S.Paragraph>
        {getFullName(initials, firstName, nameAffix, lastName)}
        <br />
        {getStreet(houseNumber, houseNumberAddition, street)}
        <br />
        {postalCode} {city}
        <br />
        {emailAddress}
        <br />
        {phoneNumber}
        <br />
        {getGender(gender)}
        <br />
        {dateOfBirth}
        <br />
      </S.Paragraph>
      {newsletterSubscription && (
        <S.Paragraph flex>
          <S.Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </S.Icon>{' '}
          Ik wil informatie ontvangen over programma&apos;s, evenementen en
          aanbiedingen van BNNVARA.
        </S.Paragraph>
      )}
    </>
  );
};
Summary.propTypes = {
  initials: PropTypes.string,
  firstName: PropTypes.string,
  nameAffix: PropTypes.string,
  lastName: PropTypes.string,
  gender: PropTypes.string,
  dateOfBirth: PropTypes.string,
  postalCode: PropTypes.string,
  houseNumber: PropTypes.number,
  houseNumberAddition: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  emailAddress: PropTypes.string,
  phoneNumber: PropTypes.string,
  newsletterSubscription: PropTypes.string,
  membership: PropTypes.string,
};
